<template>
  <div class="container">
    <template v-if="!rule" v-show="isloaded">
      <div class="header">奖励说明</div>
      <div class="rule">
        <p class="title">一、活动时间：</p>
        <p>4月1日-4月30日</p>
      </div>
      <div class="rule">
        <p class="title">二、活动规则：</p>
        <p>1.VIPKID注册用户（推荐人或“您”）分享活动海报，每推荐一位新用户（被推荐人），通过推荐人活动海报注册VIPKID用户，并首次购买VIPKID数学思维正价班课程。当被推荐人已完成6节课程且未退费（即达成奖励条件），则推荐人即可获得能量石，活动期间推荐人推荐新用户不限人数，相应的能量石奖励不设上限，每邀请1位好友付费即可得10000能量石。</p>
        <p>2.活动期间，当达成奖励条件后，推荐人奖励的能量石将在被推荐者第6节正式课结束后发放，您可在【VIPKID英语APP】-【我】-【能量石】中查看，若同一账号下关联有多位学员（一个家庭多个孩子），参与活动获得的奖励将默认存入第一位孩子的账户中。</p>
      </div>
      <div class="rule">
        <p class="title">三、注意事项：</p>
        <p>1.推荐人活动海报的分享时间为：4月1日-4月30日。</p>
        <p>2.奖品不予兑现，仅限获奖账户使用，不可转赠或转让。</p>
        <p>3.本活动所有数据以VIPKID系统数据为准。同一VIPKID账号，或账号不同手机号、身份证相同，或账号不同但名下VIPKID学员有交叉，符合以上任一条件均视为同一用户。任何人不应利用本次活动进行违法行为（如博彩、滥发短信、微信骚扰行为等）。也不得以任何不正当手段或舞弊方式参与本次活动（虚假用户、虚拟运营商注册、同一用户通过不同账号互相邀请等）。对于本平台用户，一经发现前述情形，本平台有权在不事先通知的前提下取消此用户参与本次活动的资格、收回所获奖品。如其行为构成犯罪，本平台有权移交相应司法机关处理；如因其行为给本平台造成损失，同时应当承担赔偿责任。</p>
        <p>4.如有疑问请拨打客服电话95056953，在法律允许的范围内，VIPKID拥有对本次活动进行解释的权利。</p>
      </div>
    </template>
    <template v-else>
      <div class="header" v-if="rule.header">{{rule.header}}</div>
      <div class="rule" v-for="item in rule.category" :key="item.title">
        <p class="title" v-if="item.title">{{item.title}}</p>
        <p v-for="it in item.list" :key="it">{{it}}</p>
      </div>
    </template>
  </div>
</template>
<script>
import { getConfigListByGroup } from '@/api/config'
export default {
  data () {
    return {
      rule: '',
      isloaded: false
    }
  },
  async created () {
    const configinfo = await getConfigListByGroup({
      group: 'officialAccount'
    })
    this.isloaded = true
    if (configinfo.code === 200 && configinfo.data.length > 0) {
      let info = JSON.parse(configinfo.data[0].value)
      this.rule = JSON.parse(info.desc)
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .container{
    padding:30px 40px;
    color:#333;
  }
  .header{
    font-size:34px;
    text-align: center;
  }
  .rule{
    margin-top:20px;
    color:#999;
    font-size:28px;
    p{
      line-height:36px;
      margin-top:10px;
    }
  }
  .title{
    font-size:26px;
    color:#666;
    font-size:30px;
  }
</style>
